import { TextProps, parseContent } from '@features/powerpoint';
import { theme } from '@features/executive-report/domain/theme';
import { headerTabs } from '../header-tabs';

export const staticTexts: TextProps[] = [
  ...headerTabs('overview'),
  {
    text: 'Brand Objective'.toUpperCase(),
    options: {
      fontSize: 18,
      color: theme.colors.white,
      bold: true,
      h: 0.4,
      w: 2.75,
      x: 0.55,
      y: 2.05,
    },
  },
  {
    text: parseContent('<b>CPIV</b> (cost per incremental visit)'),
    options: {
      fontSize: 12,
      color: theme.colors.white,
      h: 0.34,
      w: 3,
      x: 0.55,
      y: 4.88,
    },
  },
  {
    text: parseContent(
      '<lci>Foot traffic</lci> is measured by the number visits to specific, physical locations. Location visits are based on the number of observed visits after exposure to advertising.'
    ),
    options: {
      fontSize: 12,
      color: theme.colors.white,
      h: 0.5,
      w: 8.37,
      x: 4.27,
      y: 2.26,
    },
  },
  {
    text: 'Overall'.toUpperCase(),
    options: {
      fontSize: 7,
      color: theme.colors.white,
      h: 0.22,
      w: 0.89,
      x: 10.4,
      y: 2.87,
    },
  },
  {
    text: parseContent(
      '<lci>Who, what</lci> and <lci>where</lci> are the three primary indicators to understand drivers of visit incrementality'
    ),
    options: {
      fontSize: 12,
      color: theme.colors.white,
      h: 0.3,
      w: 8.63,
      x: 4.5,
      y: 6.47,
    },
  },
];
